import React from 'react';
import PropTypes from 'prop-types';

import { Hotkey } from 'ui-components/components/hotkey';

import { useUserSettingAdvancedHotkeys } from './hooks';

export const AdvancedHotkey = ({ children = null, hotkey }) => {
  const { areAdvancedHotkeysEnabled } = useUserSettingAdvancedHotkeys();

  const hotkeyToUse = !areAdvancedHotkeysEnabled ? undefined : hotkey;

  return <Hotkey hotkey={hotkeyToUse}>{children}</Hotkey>;
};

AdvancedHotkey.propTypes = {
  children: PropTypes.node,
  hotkey: PropTypes.object.isRequired,
};
